import fetch from "../fetch";

export default ({ dealCode, trancheId, id }) =>
  fetch({
    method: "DELETE",
    path: `/clo/deals/${dealCode}/tranche-prices/${trancheId}/tranche-ratings/${id}`
  });
